import { BaseClass } from './BaseClass';
import { PERMISSIONS } from './Permissions';

export class Configurations extends BaseClass {
  Templates: Templates;
  Configs: Configs;
  BrandTable: BaseClass;
  RecipeAllergens: BaseClass;
  constructor(obj: any = PERMISSIONS.Configurations) {
    super(obj);
    this.Templates = new Templates(obj.Templates);
    this.Configs = new Configs(obj.Configs);
    this.BrandTable = new BaseClass(obj.BrandTable);
    this.RecipeAllergens = new BaseClass(obj.RecipeAllergens);
  }
}

class Templates {
  WebCustomer: BaseClass;
  MobileCustomer: BaseClass;
  WebBusiness: BaseClass;
  MobileBusiness: BaseClass;
  WebAdminPortal: BaseClass;

  constructor(obj: any = PERMISSIONS.Configurations) {
    this.WebCustomer = new BaseClass(obj.WebCustomer);
    this.MobileCustomer = new BaseClass(obj.MobileCustomer);
    this.WebBusiness = new BaseClass(obj.WebBusiness);
    this.MobileBusiness = new BaseClass(obj.MobileBusiness);
    this.WebAdminPortal = new BaseClass(obj.WebAdminPortal);
  }
}

class Configs {
  Order: BaseClass;
  Reservation: BaseClass;

  constructor(obj: any = PERMISSIONS.Configurations) {
    this.Order = new BaseClass(obj.Order);
    this.Reservation = new BaseClass(obj.Reservation);
  }
}
